import { axiosV1 } from 'interceptors/axios';
import { decryptResponse } from 'utils/token';

type RangeInput = {
  from: number;
  to: number;
};

type CheckClassRangeOverlapsProps = {
  holdingClassId?: string;
  ranges: RangeInput[];
  excludeKeys?: RangeInput[];
};

export const checkClassRangeOverlaps = async ({
  holdingClassId,
  ranges,
  excludeKeys,
}: CheckClassRangeOverlapsProps) => {
  const body = { holdingClassId, ranges, excludeKeys };

  const { data } = await axiosV1.post(
    '/holdingClasses/check-range-overlaps',
    body
  );

  const decodedData: any = await decryptResponse(data);

  return decodedData;
};
